module.exports = __webpack_public_path__ + "static/img/page_03.18f29af.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page_03.jpeg
// module id = HyYt
// module chunks = 0